/**
 * Local plain-string `gettext` replacing `@eventbrite/i18n` (fleet pattern —
 * the eb-ui GenericLazyString is unsafe to render under React 19).
 *
 * eb-ui's i18n is i18next with `interpolation: { prefix: '%(', suffix: ')s',
 * escapeValue: false }` (see eb-ui packages/infra/i18n/src/i18n.ts:39-42), so
 * for the shipped en_US catalog gettext is a byte-exact `%(name)s`
 * substitution — which this shim reproduces. Locale catalogs can be layered in
 * by the consuming app via `setMessages` before render.
 */

let activeMessages: Record<string, string> = {};

/** Optional message catalog, keyed by the source (msgid) string. */
export const setMessages = (messages: Record<string, string>): void => {
    activeMessages = messages || {};
};

export const gettext = (
    key: string,
    interpolation?: Record<string, string | number>,
): string => {
    const template = activeMessages[key] ?? key;

    if (!interpolation) {
        return template;
    }

    return template.replace(/%\(([^)]+)\)s/g, (match, name: string) =>
        name in interpolation ? String(interpolation[name]) : match,
    );
};
